var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedstep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#02BD9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15 14.365a.358.358 0 01-.254.106.344.344 0 01-.267-.106l-3.523-3.53a.342.342 0 010-.494.34.34 0 01.492 0l3.29 3.297L15.4 6.106a.35.35 0 01.501 0 .355.355 0 010 .494l-7.75 7.765z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10H20",
    stroke: "#02BD9C",
    strokeLinecap: "round"
  })));
}
SvgCompletedstep.displayName = 'Completedstep';
export default SvgCompletedstep;